import { Component, OnInit } from "@angular/core";
import { AuthService } from "./shared/services/auth.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent  implements OnInit {

  title = "Legal Assure";

  constructor(private authService:AuthService,private router:Router) {
  
      
    }

  ngOnInit(): void {
    if(this.authService.isLoggedIn()){
       this.router.navigate(['/sample-page/clients'])
    }
  }
  

}
